export default {
    methods:{
        getFullAddress(logradouro:string, numero:string, complemento:string, bairro:string, pontoReferencia:string){
            const addressParts = [
              {
                name: logradouro,
                before: ''
              },
              {
                name: numero,
                before: ', '
              },
              {
                name: complemento,
                before: '/ '
              },
              {
                name: bairro,
                before: ' - '
              },
              {
                name: pontoReferencia,
                before: ', '
              }
            ]
            let fullAddress = ''
            addressParts.forEach((part) => {
              if(part.name){
                fullAddress += part.before + part.name
              }
            })
            return fullAddress
        }
    }
}